import React from 'react'
import RoznicaCITRZiSRowStyle from '../../styles/RoznicaCITRZiSRowStyle'
import RoznicaCITRZiSRow from './RoznicaCITRZiSRow'
import RoznicaCITRZiSExpandableRow from './RoznicaCITRZiSExpandableRow'

const RoznicaCITRZiSList = props => {
  return props.dane.map((element, index) =>
    element.KwotySzczegolowe ? (
      <RoznicaCITRZiSExpandableRow
        isExpanded={props.isExpanded}
        isDetailsVisible={props.isDetailsVisible}
        aktualizujSumy={props.aktualizujSumy}
        onSetSectionDataArray={props.onSetSectionDataArray}
        index={index}
        key={index}
        opis={element.Nazwa}
        kwotaRP={element.KwotaRP}
        kwotaRB={element.KwotaRB}
        kwotaRP_Kapitalowe={element.KwotaRP_Kapitalowe}
        kwotaRB_Kapitalowe={element.KwotaRB_Kapitalowe}
        kwotaRP_Inne={element.KwotaRP_Inne}
        kwotaRB_Inne={element.KwotaRB_Inne}
        czyKwotyWTysiacach={props.czyKwotyWTysiacach}
        pozycjeUzytkownika={element.PozycjeUzytkownika}
        uszczegolawialne={element.Uszczegolawialne}
      />
    ) : (
      <RoznicaCITRZiSRowStyle key={index}>
        <RoznicaCITRZiSRow
          aktualizujSumy={props.aktualizujSumy}
          index={index}
          opis={element.Nazwa}
          kwotaRP={element.KwotaRP}
          kwotaRB={element.KwotaRB}
          nameA="KwotaRP"
          nameB="KwotaRB"
          readOnly={index === 9}
          czyKwotyWTysiacach={props.czyKwotyWTysiacach}
        />
      </RoznicaCITRZiSRowStyle>
    ),
  )
}

export default RoznicaCITRZiSList
